/* @jsxImportSource react */

import type { FC, ReactNode } from 'react';

export type MinimalHeaderLayoutProps = {
  children?: ReactNode;
};

export const MinimalHeaderLayout: FC<MinimalHeaderLayoutProps> = ({ children }) => (
  <>
    <div className="mx-auto flex max-w-screen-xl items-center max-lg:shadow-sm">
      <header className="page-header grid w-full">{children}</header>
    </div>

    <div className="border-color-grey border-b max-lg:hidden" />
  </>
);
